import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const EMAIL_NAME = 'email';

interface Props {
  name?: string;
}

const InputEmail: FC<Props> = ({ name = EMAIL_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) => {
          if (!value) return i18n.t('Uzupełnij e-mail');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
            return i18n.t('Podaj prawidłowy adres e-mail');
          return true;
        },
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem className="col-span-3 sm:col-span-2">
          <FormControl>
            <Input
              label={i18n.t('Adres e-mail')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              type="email"
              inputMode="email"
              autoComplete="email"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputEmail;
